module.exports = __webpack_public_path__ + "img/card.4e64bc1d.jpg";